import Log from './log.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable eqeqeq */
function isUndefined(x) {
    return x === null || x === undefined;
}
function isUndefinedOrEmpty(x) {
    return x === null || x === undefined || x === '';
}
function omit(obj, ...propNames) {
    const result = Object.assign({}, obj);
    propNames.forEach((p) => delete result[p]);
    return result;
}
function mergeOrDelete(obj, name, value) {
    if (!obj)
        return obj;
    const result = Object.assign({}, obj);
    if (value === undefined) {
        delete result[name];
    }
    else {
        result[name] = value;
    }
    return result;
}
function pick(obj, ...propNames) {
    if (isUndefined(obj))
        return {};
    return Object.keys(obj).filter((k) => propNames.includes(k)).reduce((res, k) => {
        res[k] = obj[k];
        return res;
    }, {});
}
function last(arr) {
    if (arr && arr.length > 0)
        return arr[arr.length - 1];
    return undefined;
}
function isObject(object) {
    return object != null && typeof object === 'object';
}
function isDeepEqual(obj1, obj2) {
    if (isObject(obj1) && isObject(obj2)) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length)
            return false;
        // eslint-disable-next-line no-restricted-syntax
        for (const key of keys1) {
            if (!isDeepEqual(obj1[key], obj2[key])) {
                return false;
            }
        }
        return true;
    }
    return obj1 === obj2;
}
/**
 * Genera un nuovo Guid.
 * @returns nuovo guid.
 */
function uuid(template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx') {
    let d = new Date().getTime(); // Timestamp
    // Time in microseconds since page-load or 0 if unsupported
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
    return template.replace(/[xy]/g, (c) => {
        let r = Math.random() * 16; // random number between 0 and 16
        if (d > 0) { // Use timestamp until depleted
            // eslint-disable-next-line no-bitwise
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        }
        else { // Use microseconds since page-load if supported
            // eslint-disable-next-line no-bitwise
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        // eslint-disable-next-line no-mixed-operators, no-bitwise
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}
function isNotNumber(value) {
    return Number.isNaN(Number(value));
}
class CancellablePromise extends Promise {
    constructor(func) {
        let promiseCancelled = false;
        let cancelledCallback = null;
        function checkCancelled(reject) {
            if (promiseCancelled) {
                if (cancelledCallback) {
                    cancelledCallback(reject);
                }
                return true;
            }
            return false;
        }
        const executor = (cancellableResolve, cancellableReject) => {
            func((value) => {
                if (!checkCancelled(cancellableReject)) {
                    cancellableResolve(value);
                }
            }, (reason) => {
                if (!checkCancelled(cancellableReject)) {
                    cancellableReject(reason);
                }
            });
        };
        super(executor);
        this.cancel = () => {
            promiseCancelled = true;
        };
        this.cancelled = (callback) => {
            cancelledCallback = callback;
            return this;
        };
    }
}
function isEqualUndefined(v1, v2) {
    if (isUndefined(v1) && isUndefined(v2))
        return true;
    return v1 === v2;
}
function isEqualUndefinedOrEmpty(v1, v2) {
    if (isUndefinedOrEmpty(v1) && isUndefinedOrEmpty(v2))
        return true;
    return v1 === v2;
}
function setArrayPropRecursive(prop, properties, value, obj, stato) {
    const propName = prop.substring(0, prop.indexOf('['));
    const propIndexStr = prop.substring(prop.indexOf('[') + 1, prop.indexOf(']'));
    const propIndex = parseInt(propIndexStr, 10);
    if (properties.length > 0) {
        obj[propName] = JSON.parse(JSON.stringify(stato[propName] || {}));
        if (obj[propName][propIndex] == null) {
            obj[propName][propIndex] = {};
        }
        setPropRecursive(properties, value, obj[propName][propIndex], stato[propName][propIndex] || {});
    }
    else {
        obj[propName][propIndex] = value;
    }
}
function setObjectPropRecursive(prop, properties, value, obj, stato) {
    if (stato[prop] !== null && typeof stato[prop] === 'object') {
        obj[prop] = JSON.parse(JSON.stringify(stato[prop] || {}));
    }
    else {
        obj[prop] = stato[prop] || {};
    }
    setPropRecursive(properties, value, obj[prop], stato[prop] || {});
}
const setPropRecursive = (properties, value, obj, stato) => {
    const [prop] = properties;
    properties.splice(0, 1);
    if (prop.indexOf('[') != -1) {
        setArrayPropRecursive(prop, properties, value, obj, stato);
    }
    else if (properties.length > 0) {
        setObjectPropRecursive(prop, properties, value, obj, stato);
    }
    else {
        obj[prop] = value;
    }
};
function deleteUndefinedProps(object) {
    if (isUndefined(object))
        return;
    Object.keys(object).forEach((key) => {
        const value = object[key];
        if (isUndefined(value)) {
            try {
                delete object[key];
            }
            catch (e) {
                Log.error(`deleteUndefinedProps: Impossibile eliminare la proprietà ${key}`);
            }
        }
        if (typeof value === 'object' || Array.isArray(value)) {
            deleteUndefinedProps(value);
        }
    });
}
function isDeepProp(props) {
    return props.indexOf('.') != -1 || props.indexOf('[') != -1 || props.indexOf(']') != -1;
}
/**
 * Assegna alla proprietà props di obj il valore value.
 * Se la proprietà è annidata, lo stato dell'oggetto è copiato da stato.
 * @param props path della proprietà, ex: Dichiarativo.Messaggi[2]
 * @param value valore
 * @param destinationObject oggetto di destinazione
 * @param currentObject stato iniziale
 */
function setDeepProp(props, value, destinationObject, currentObject) {
    const name = props;
    if (name.indexOf('.') != -1) {
        const properties = name.split('.');
        setPropRecursive(properties, value, destinationObject, currentObject);
    }
    else {
        destinationObject[name] = value;
    }
}
function getByArrayIndex(temp, prop) {
    const propName = prop.substring(0, prop.indexOf('['));
    const propIndexStr = prop.substring(prop.indexOf('[') + 1, prop.indexOf(']'));
    const propIndex = parseInt(propIndexStr, 10);
    if (temp[propName] == undefined) {
        return undefined;
    }
    return temp[propName][propIndex];
}
/**
 * Return the value of a stato property by props path, or '' if the path doesn't exist.
 * props uses the dot notation to identity an object property or
 * [index] to identify an array item.
 * ex: Dichiarativo.Messaggi[2]
 * @param props return property path
 * @param state source object where extract the value.
 */
function getDeepProp(props, state) {
    const name = props;
    if (name.indexOf('.') != -1) {
        const properties = name.split('.');
        let temp = state;
        for (let i = 0; i < properties.length; i += 1) {
            const prop = properties[i];
            if (prop.indexOf('[') != -1) {
                temp = getByArrayIndex(temp, prop);
            }
            else {
                temp = temp[prop];
            }
            if (temp == undefined) {
                return undefined;
            }
        }
        return temp == null ? undefined : temp;
    }
    return state[name] == null ? undefined : state[name];
}
/**
 * Funzione per il clone deep di un oggetto.
 * Se una proprietà ha come valore un oggetto, verifica se questo è un'istanza di una classe (diversa da object)
 * ed in questo caso non clona il valore.
 */
function cloneDeep(obj) {
    if (Array.isArray(obj)) {
        return obj.map((item) => cloneDeep(item));
    }
    if (obj && typeof obj === 'object') {
        if (Object.getPrototypeOf(obj) === Object.getPrototypeOf({})) {
            const newObj = {};
            Object.entries(obj).forEach(([key, value]) => {
                newObj[key] = cloneDeep(value);
            });
            return newObj;
        }
        if (typeof obj.clone === 'function') {
            return obj.clone();
        }
    }
    return obj;
}

export { CancellablePromise, cloneDeep, deleteUndefinedProps, getDeepProp, isDeepEqual, isDeepProp, isEqualUndefined, isEqualUndefinedOrEmpty, isNotNumber, isObject, isUndefined, isUndefinedOrEmpty, last, mergeOrDelete, omit, pick, setDeepProp, uuid };
